import React, { useCallback, useEffect, useState } from 'react';
import { OrgList } from '@/components/admin/OrgList';
import { apiFetch } from '@/lib/apiFetch';
import type { Organization } from '@/types/database';
import { AdminPageShell } from '../_components/AdminPageShell';

export const AdminOrganizationsPage: React.FC = () => {
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadOrganizations = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiFetch('/api/organizations');
      if (!res.ok)
        throw new Error(`Failed to load organizations: ${res.status}`);
      const json = await res.json();
      setOrganizations(
        (Array.isArray(json) ? json : (json?.data ?? [])) as Organization[]
      );
    } catch (err) {
      setError(
        err instanceof Error ? err.message : 'Failed to load organizations'
      );
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    loadOrganizations();
  }, [loadOrganizations]);

  return (
    <AdminPageShell title="Organizations">
      <OrgList
        organizations={organizations}
        loading={loading}
        error={error}
        onRefresh={loadOrganizations}
      />
    </AdminPageShell>
  );
};
